import React, {useEffect, useState} from 'react'
import type {ReactElement} from 'react'
import type {FaqItemProps} from './faq-item'

type FaqItem = ReactElement<FaqItemProps>

interface FaqProps {
	children?: FaqItem | FaqItem[]
	className?: string
}

export const Faq = ({children, className = ''}: FaqProps) => {
	const [isContextUsed, setIsContextUsed] = useState<boolean>(false)

	useEffect(() => {
		setIsContextUsed(Boolean(document.querySelector('#theme')))
	}, [])

	return (
		<dl
			className={`${
				isContextUsed ? 'bg-alternative' : 'bg-white'
			} shadow-tertiary rounded-lg ${className}`}
		>
			{children}
		</dl>
	)
}
